import {Component, Input, ViewChild} from '@angular/core';
import {PageNames} from '../../shared/page-names.enum';
import {NavigationService} from '../../services/navigation/navigation.service';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {PriceUtils} from '../../shared/utils/price/price.utils';
import {Router} from '@angular/router';
import {
  OrderingModalManagerComponent
} from '../../modals/ordering-modals/ordering-modal-manager/ordering-modal-manager.component';
import {OmapiIdConstants} from '../../shared/omapi-id-constants';
import {SelectableNavigationItem} from '../../model/selectable-navigation-item';
import {BaseActions} from '../../shared/base-actions';
import {Order} from '../../model/order';
import {LanguageService} from '../../services/language/language.service';
import {ImageUtils} from '../../shared/utils/image/image-utils';
import {OmapiIdsUtils} from '../../shared/utils/omapi-ids/omapi-ids-utils';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';

@Component({
  selector: 'app-deep-linking-option',
  templateUrl: './deep-linking-option.component.html',
  styleUrls: ['./deep-linking-option.component.less']
})
export class DeepLinkingOptionComponent extends BaseActions implements SelectableNavigationItem {
  ownerComponent = PageNames.DEEP_LINKING;
  active: boolean;
  name: string;
  order: Order;

  @ViewChild('orderModal')
  orderingModal: OrderingModalManagerComponent;
  @Input()
  x: number;
  @Input()
  y: number;
  // TODO replace ompaiId with pack.omapiId
  @Input()
  omapiId: string;

  @Input()
  pack: TvShopEntertainmentPack;

  constructor(private navigationService: NavigationService,
              private router: Router,
              private languageService: LanguageService,
              private stateService: TvShopStateService
  ) {
    super();
  }

  public getLogoUrl(): string {
    return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
  }


  activate(active: boolean): void {
    this.active = active;
  }

  canNavigateToDirection(keyCode: number): boolean {
    return true;
  }

  onBack(): void {
    this.navigationService.resetPage();
    window.close();
  }

  emitOnEnterPressed(event: Order): void {
    this.order = event;
    this.openOrderModal();
  }

  onEnter() {
  }

  navigateToDetailPage(): void {
    this.stateService.setSelectedTvShopEntertainmentPack(this.pack);
    this.router.navigateByUrl('/product-details/' + this.omapiId + '?' + 'origin=deeplink');
  }

  openOrderModal(): void {
    this.orderingModal.openModal();
  }

  productName(): string {
    return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.omapiId);
  }

  get hasPromo(): boolean {
    return this.pack && this.pack.priceDetail && this.pack.priceDetail.hasPromo();
  }

  get promoLabel(): string {
    return this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoLabel : undefined;
  }

  get promoDuration(): number {
    return this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoDuration : undefined;
  }

  get textIntegerPart(): string {
    return this.pack && this.pack.priceDetail ? this.pack.priceDetail.price.integerPart() : undefined;
  }

  get textDecimalPart(): string {
    return this.getTextDecimalPart(this.pack && this.pack.priceDetail ? this.pack.priceDetail.price.decimalPart() : undefined);
  }

  get priceBeforeComma(): string {
    return this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoPrice.integerPart() : undefined;
  }

  get getPriceTextDecimalPart(): string {
    return this.getTextDecimalPart(
      this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoPrice.decimalPart() : undefined);
  }

  get rscOmapiId(): string {
    return OmapiIdsUtils.getCorrectIdForResource(this.omapiId);
  }

  isSelectable(): boolean {
    return true;
  }

  isSubscribed(): boolean {
    return false;
  }

  get currentLang(): string {
    return this.languageService.getCurrentLanguage().toLowerCase();
  }

  private getTextDecimalPart(price: string): string {
    return PriceUtils.prefixDecimalPart(price, this.currentLang);
  }
}
